import { TextField } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import InputStack from "../../../Styled/Stack/InputStack";

const getLengthInBounds = (l, ratio) => {
  console.log(l, ratio, l * ratio);
  return Math.ceil(l * ratio);
};

const getRemainingLength = (length, partialLength) => {
  const newOtherPartialLength = length - partialLength;
  return newOtherPartialLength >= 0 ? newOtherPartialLength : 0;
};

const handleLengthChange = (
  newValue,
  length,
  setter,
  otherSetter,
  lengthSetter
) => {
  if (newValue < 0) return;
  if (newValue > 1_000_000_000) return;
  setter(newValue);
  if (newValue > length) {
    otherSetter(0);
    lengthSetter(newValue);
    return;
  }
  otherSetter(getRemainingLength(length, newValue));
};

const Lengths = ({ lengths, onChange }) => {
  const { t } = useTranslation();
  const [length, setLengthL] = useState(lengths.length);
  const [lengthLA, setLengthLA] = useState(lengths.lengthLA);
  const [lengthLB, setLengthLB] = useState(lengths.lengthLB);

  // Update LA and LB when L changes
  const handleLengthLChange = useCallback(
    (event) => {
      const newL = parseFloat(event.target.value) || 0; // Get the new L value or default to 0
      if (newL < 0) return;
      if (newL > 1_000_000_000) return;
      setLengthL(newL);

      // Adjust LA and LB to keep the equation L = LA + LB true
      const total = lengthLA + lengthLB;
      if (total === 0) {
        setLengthLA(newL);
        return;
      }
      const ratio = total > 0 ? newL / total : 0; // Ratio to maintain proportionality

      setLengthLA((lastLA) => getLengthInBounds(lastLA, ratio));
      setLengthLB((lastLB) => getLengthInBounds(lastLB, ratio));
    },
    [lengthLA, lengthLB]
  );

  // Update LA and recalculate LB to keep L = LA + LB
  const handleLengthLAChange = useCallback(
    (event) => {
      const newLA = parseFloat(event.target.value) || 0;
      handleLengthChange(newLA, length, setLengthLA, setLengthLB, setLengthL);
    },
    [length]
  );

  // Update LB and recalculate LA to keep L = LA + LB
  const handleLengthLBChange = useCallback(
    (event) => {
      const newLB = parseFloat(event.target.value) || 0;
      handleLengthChange(newLB, length, setLengthLB, setLengthLA, setLengthL);
    },
    [length]
  );

  useEffect(() => {
    onChange && onChange({ length, lengthLA, lengthLB });
  }, [length, lengthLA, lengthLB, onChange]);

  return (
    <InputStack>
      {/* L TextField */}
      <TextField
        label={`L, ${t("units.length.mm")}`}
        variant="outlined"
        fullWidth
        type="number"
        value={length} // Bind value to state
        sx={{ flexBasis: "100%" }}
        onChange={handleLengthLChange} // Use callback for handling input change
      />
      {/* LA TextField */}
      <TextField
        label={
          <div>
            L<sub>A</sub>, {t("units.length.mm")}
          </div>
        }
        variant="outlined"
        fullWidth
        type="number"
        value={lengthLA} // Bind value to state
        sx={{ flexBasis: { xs: "100%", sm: "45%" } }}
        onChange={handleLengthLAChange} // Use callback for handling input change
      />

      {/* LB TextField */}
      <TextField
        label={
          <div>
            L<sub>B</sub>, {t("units.length.mm")}
          </div>
        }
        variant="outlined"
        fullWidth
        type="number"
        value={lengthLB} // Bind value to state
        sx={{ flexBasis: { xs: "100%", sm: "45%" } }}
        onChange={handleLengthLBChange} // Use callback for handling input change
      />
    </InputStack>
  );
};

export default Lengths;
